











import FormField from '@/components/FormField'

export default {
    name: 'TextField'

    extends: FormField
}
